export default __webpack_public_path__ + "static/media/eye-close.590d6ab3.png";